import { Box, Button } from "@mui/material";
import { useAppointmentsList } from "../../../queries/use-get-appointments";
import { DEF_PAGINATION } from "../../../utils/utils";
import OutlineCard from "../../../components/OutlineCard";
import Flex from "../../../components/Flex";
import { useNavigate } from "react-router-dom";
import Text from "../../../components/Text";
import { store } from "../../../redux/store";
import { setCallData } from "../../../redux/feature/join-room/JoinRoomSlice";
import { getStoredRealm } from "@/utils/auth-storage";

//todo: need to remove
const PatientHome = () => {
  const user = sessionStorage?.getItem("user");
  const uuid = user ? JSON.parse(user)?.uuid : "";

  const { data } = useAppointmentsList({
    providerGroupId: getStoredRealm(),
    pagination: DEF_PAGINATION,
    patientUuid: uuid,
  });

  const appointmentList = data?.data.content;
  const navigate = useNavigate();

  function joinInstantAppointment() {
    const appointment = appointmentList?.[0];
    const patientIdParam = appointment?.patientId
      ? `&patientid=${appointment?.patientId}`
      : "";
    const appointmentIdParam = appointment?.uuid
      ? `&appointmentid=${appointment?.uuid}`
      : "";

    store.dispatch(
      setCallData({
        patientId: appointment?.patient?.uuid,
        appointmentId: appointment?.uuid,
        patientName: appointment?.patientName ?? "",
        providerName: appointment?.providerName ?? "",
        startTime: appointment?.startTime,
        role: 0,
      })
    );
    navigate(
      `/app/preview?room=${appointment?.room}&role=${0}&providerName=${
        appointment?.providerName ?? ""
      }&patientName=${appointment?.patientName ?? ""}&startTime=${
        appointment?.startTime
      }${patientIdParam}${appointmentIdParam}`
    );
  }

  return (
    <Box>
      <Flex gap={1}>
        <OutlineCard>
          <Text>{`Appointment ID :${appointmentList?.[0]?.uuid}`}</Text>
          <Text>{`Room ID :${appointmentList?.[0]?.room}`}</Text>
          <Text>{`Provider Name :${appointmentList?.[0]?.providerName}`}</Text>

          <Button variant="contained" onClick={joinInstantAppointment}>
            Join Visit
          </Button>

          <Button
            style={{ marginLeft: "30px" }}
            variant="contained"
            onClick={() => {
              navigate("/app/patient/intake");
            }}
          >
            widget
          </Button>
        </OutlineCard>
      </Flex>
    </Box>
  );
};

export default PatientHome;
